module.exports = __webpack_public_path__ + "img/csm_bruno_sauter_dea28c1e0b.f5172e6e.jpg";